import { type Dispatch } from "@reduxjs/toolkit";
import groupsDataService from "features/People/services/groupsDataService";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/groupMembersInfoSlice";
import { type Filters } from "../../../../../../utils/queryUtils";
import { escapeTerm } from "../../../../../../utils/searchUtils";
import KnownHttpHeaders from "../../../../../Application/services/knownHttpHeaders";

interface GetGroupMembersParams {
  groupId: number;
  skip: number;
  top: number;
  orderByParams?: string;
  filter?: string | Filters;
  search?: string;
}

export const fetchGroupUsersForList =
  ({ groupId, skip, top, orderByParams, filter, search }: GetGroupMembersParams) =>
  async (dispatch: Dispatch) => {
    dispatch(fetchBegin());
    try {
      const searchTerm = escapeTerm(search);
      const { data, headers } = await groupsDataService.getGroupMembersV2(
        groupId,
        skip,
        top,
        orderByParams,
        filter,
        searchTerm,
      );

      dispatch(fetchSuccess({ items: data, totalCount: parseInt(headers[KnownHttpHeaders.RecordsCount]) }));
    } catch (e) {
      dispatch(fetchFailure(e as Error));
    }
  };
